import { BriefingResourceItem, IResourceModel } from '@/shared/model/briefing-widget.model';
import { getHostName, getLinkEmbedYoutube } from '@/util/ds-util';
import { randomSize } from '@/util/common-util';

export function map2ResourceItem(briefing: BriefingResourceItem): IResourceModel {
  let type = '';
  let videoUrl = '';
  let channel = '';
  if (briefing.parentDocDetail?.media_type?.includes('REPORT')) {
    type = 'REPORT';
  } else if (briefing.parentDocDetail?.media_type?.includes('CHAT_HISTORY')) {
    type = 'CHAT_HISTORY';
  } else if (briefing.parentDocDetail?.media_type?.includes('YOUTUBE')) {
    videoUrl = getLinkEmbedYoutube(briefing.parentDocDetail.source_uri);
    if (videoUrl.includes('https://www.youtube.com/embed/')) {
      type = 'VIDEO';
    } else {
      type = 'DISCOVERY';
    }
  } else {
    type = briefing.documentType;
  }
  if (!briefing.parentDocDetail?.is_group) {
    if (briefing.parentDocDetail?.datasource_channel_type) {
      switch (briefing.parentDocDetail.datasource_channel_type[0]) {
        case 'GOOGLE_DRIVE':
          channel = 'Google Driver';
          break;
        case 'DROP_BOX':
          channel = 'Dropbox';
          break;
        case 'ONE_DRIVE':
          channel = 'OneDrive';
          break;
        default:
          channel = getHostName(briefing.parentDocDetail.source_uri);
          break;
      }
    } else {
      channel = getHostName(briefing.parentDocDetail.source_uri);
    }
    if (briefing.parentDocDetail.source_uri.includes('youtube.com')) {
      channel = 'YouTube';
    }
  }
  try {
    return {
      _id: briefing.parentDocDetail._id,
      docId: briefing.parentDocDetail?.parent_doc_id?.[0],
      isBookmarked: !!briefing.is_bookmarked,
      bpId: briefing.parentDocDetail?.briefingpage_id?.[0] || briefing.parentDocDetail?.briefing_page_id?.[0],
      channel: channel?.replace(/\b\w/g, char => char.toUpperCase()),
      publishAt: briefing.parentDocDetail.published_at,
      title: briefing.parentDocDetail.title,
      content: briefing.parentDocDetail.source_summary,
      thumbnail: briefing.parentDocDetail.image_uri_thumbnail,
      type,
      userProfile: briefing.userProfile,
      size: briefing.parentDocDetail.image_uri_thumbnail ? randomSize() : '1x1',
      originParentDocDetail: briefing.parentDocDetail,
      url: briefing.parentDocDetail.source_uri,
      videoUrl: videoUrl,
      isGroup: briefing.parentDocDetail?.is_group,
      isGroupChildren: briefing.parentDocDetail?.is_group_children,
      originDocumentType: briefing.documentType,
      writer: briefing.parentDocDetail.writer?.[0],
      owner_user_key: briefing?.parentDocDetail?.owner_user_key
        ? briefing?.parentDocDetail?.owner_user_key
        : briefing?.owner_user_key
        ? briefing?.owner_user_key
        : briefing?.originParentDocDetail?.owner_user_key
        ? briefing?.originParentDocDetail?.owner_user_key
        : null,
      collected_quality: briefing?.parentDocDetail?.collected_quality,
      other_info: briefing?.parentDocDetail?.other_info,
      cmp_bp_id: briefing?.parentDocDetail?.cmp_bp_id,
      requestId: briefing?.requestId ? briefing?.requestId : undefined,
      countComment: briefing?.parentDocDetail?.count_comment || undefined,
      countSubscribe: briefing?.parentDocDetail?.count_subscribe || undefined,
      countView: briefing?.parentDocDetail?.count_view || undefined,
      subscribeStatus: briefing?.parentDocDetail?.subscribeStatus || undefined,
    } as IResourceModel;
  } catch (e) {
    console.error(e);
    return {} as IResourceModel;
  }
}
